export const BPPageRoute = '/blood-pressure';
